import React, { useEffect, useState } from "react";

import { LinearProgress, Typography } from "@mui/material";

import { GeneralModal } from "../General-modal/GeneralModal";

import "./ParsingPdfModal.styles.scss";

// import { useSetAsync } from "../../../queries/query-mutations/tagger-query-mutations";

const WAIT_UNTIL_ASK_TO_NOTIFY = 5000;

export type ParsingPdfModalProps = {
  open: boolean;
  title: string;
  text?: string;
  onClose: () => void;
  askToNotify?: boolean;
};

export const ParsingPdfModal: React.FC<ParsingPdfModalProps> = (props) => {
  const [askToNotify, setAskToNotify] = useState(props.askToNotify || false);
  // const { mutate } = useSetAsync();

  useEffect(() => {
    if (props.open && props.askToNotify) {
      setTimeout(() => {
        setAskToNotify(true);
      }, WAIT_UNTIL_ASK_TO_NOTIFY);
    } else {
      setAskToNotify(false);
    }
  }, [props.open, props.askToNotify]);

  return (
    <GeneralModal
      open={props.open}
      onClose={props.onClose}
      title={props.title}
      positiveBtn={
        askToNotify
          ? {
              text: "Notify Me",
              onClick: () => {
                // mutate();
                props.onClose();
              }
            }
          : undefined
      }
      negativeBtn={askToNotify ? { text: "Keep waiting", onClick: () => setAskToNotify(false) } : undefined}
    >
      <div className="parsing-pdf-modal__content">
        <Typography className="add-tag-modal__title" variant="body1">
          {props.text || props.title}
        </Typography>
        <LinearProgress />
        {askToNotify && (
          <>
            <div className="parsing-pdf-modal__separator" />
            <Typography className="add-tag-modal__title" variant="body1">
              This seems to be taking a long time. We will notify you when the file is ready for tagging. You can
              continue working.
            </Typography>
          </>
        )}
      </div>
    </GeneralModal>
  );
};
